module.exports = __webpack_public_path__ + "img/businessman__flatline.5eabe0a7.svg";